import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { Warning } from "~/components/icon/warning";
import { Button } from "~/components/button";
import { Text } from "~/components/text";

export const MaintenancePage: React.FC = () => {
  const { t } = useTranslation(["general"]);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background">
      <div className="mx-auto max-w-2xl text-center">
        <div className="mb-6 flex justify-center">
          <Warning className="h-16 w-16" />
        </div>
        <Text as="h1" variant="pageHeading" className="mb-4">
          {t("general:maintenanceTitle")}
        </Text>
        <Text variant="muted" className="mb-8">
          {t("general:maintenanceMessage")}
        </Text>
        <Link
          to="/contact-us"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="support-action"
        >
          <Button
            label={t("general:contactUs")}
            variant="tertiary"
            size="small"
            className="text-sm"
          />
        </Link>
      </div>
    </div>
  );
};
